export default __webpack_public_path__ + "static/media/aws-ses.c9663a32.svg";